import { type TypedDocumentNode, gql } from '@apollo/client';

import { So5FixtureEvent } from '@sorare/core/src/__generated__/globalTypes';

import { TodaysCompetition } from '../TodaysCompetition';
import type { DailyHoopsBanner_so5Fixture } from './__generated__/index.graphql';

type Props = { fixture: DailyHoopsBanner_so5Fixture };

export const DailyHoopsBanner = ({ fixture }: Props) => {
  if (!fixture.event) return null;
  if (fixture.eventType.toUpperCase() !== So5FixtureEvent.DAILY) return null;

  return <TodaysCompetition event={fixture.event} />;
};

DailyHoopsBanner.fragments = {
  so5Fixture: gql`
    fragment DailyHoopsBanner_so5Fixture on So5Fixture {
      slug
      eventType
      eventName
      event {
        ...TodaysCompetition_Event
      }
    }
    ${TodaysCompetition.fragments.Event}
  ` as TypedDocumentNode<DailyHoopsBanner_so5Fixture>,
};
